import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface IStyleProps {
  active?: boolean;
  bodyHeight?: number;
  activeColor?: string;
  hoverHighlight?: boolean;
};

export const Container = styled.main`
  position: relative;
`;

export const Section = styled.section`
  position: relative;
`;

export const InnerSection = styled.div`
  position: relative;
  max-width: 500px;
  padding: 2rem;
`;

export const AccordionContainer = styled.div`
  font-family: Roboto;
`;

export const AccordionInner = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid black;
  border-radius: 4px;
`;

export const AccordionItem = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid #dedede;
  }
  &:hover {
    background-color: ${(props: IStyleProps) => (!props.active && (props.hoverHighlight || props.hoverHighlight === undefined)) ? 'rgba(255, 115, 25, 0.05)' : 'transparent'};
  }
`;

export const AccordionTitle = styled.h3`
  margin: 0;
  padding: 15.5px 20px 13.5px 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: ${(props: IStyleProps) => (props.active && props.activeColor) ? props.activeColor: C.DARK_GRAY};
  display: flex;
  align-items: center;
`;

export const Counter = styled.span`
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
  margin-top: -10px;
`;

export const Icons = styled.div`
  margin-left: auto;
  transform: ${(props: IStyleProps) => props.active ? 'rotate(180deg)': 'rotate(0deg)'};
`;

export const AccordionBody = styled.div`
  display: ${(props: IStyleProps) => props.active ?`block`:`none`};;
  position: relative;
  padding: 0;
  margin: 0;
  overflow: ${(props: IStyleProps) => props.active ?``:`hidden`};
  transition: height 0.3s;
`;

export const AccordionContent = styled.div`
  margin: 0;
  padding-top: 1px;
  padding-left: 20px;
  padding-bottom: 18px;
  padding-right: 20px;
  height: auto;
`;